import React from "react";
import {css} from "@emotion/react";

import {mb, mh, mv} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ShowMoreButton} from "../../../atoms/ShowMoreButton";
import {VendorDetailCommercialsListItem, VendorDetailCommercialsListItemProps} from "./boxes/VendorDetailCommercialsListBox";

interface IProps {
    offers: VendorDetailCommercialsListItemProps["offer"][];
    vendorSlug: VendorDetailCommercialsListItemProps["vendorSlug"];
}

const VendorDetailCommercialsList: React.FC<IProps> = ({offers, vendorSlug}) => (
    <ul css={commercialsOffersList}>
        {offers.map((offer) => (
            <li key={offer.id} css={[mh("auto"), mv(1.5)]}>
                <VendorDetailCommercialsListItem offer={offer} vendorSlug={vendorSlug} />
            </li>
        ))}
    </ul>
);

export const VendorDetailCommercials = (props: IProps) => {
    const {offers, vendorSlug} = props;

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(4)]}>
                Nowe lokale użytkowe
            </Text>

            <VendorDetailCommercialsList offers={offers.slice(0, 5)} vendorSlug={vendorSlug} />

            {offers.length > 5 && (
                <ShowMoreButton showMoreText="Pokaż więcej inwestycji" showLessText="Pokaż mniej inwestycji">
                    <VendorDetailCommercialsList offers={offers.slice(5)} vendorSlug={vendorSlug} />
                </ShowMoreButton>
            )}
        </>
    );
};

const commercialsOffersList = css`
    list-style: none;
    padding-left: 0;
    margin: 0;
`;
import React from "react";
import {css} from "@emotion/react";

import {mb, mh, mv} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ShowMoreButton} from "../../../atoms/ShowMoreButton";
import {VendorDetailCommercialsListItem, VendorDetailCommercialsListItemProps} from "./boxes/VendorDetailCommercialsListBox";

interface IProps {
    offers: VendorDetailCommercialsListItemProps["offer"][];
    vendorSlug: VendorDetailCommercialsListItemProps["vendorSlug"];
}

const VendorDetailCommercialsList: React.FC<IProps> = ({offers, vendorSlug}) => (
    <ul css={commercialsOffersList}>
        {offers.map((offer) => (
            <li key={offer.id} css={[mh("auto"), mv(1.5)]}>
                <VendorDetailCommercialsListItem offer={offer} vendorSlug={vendorSlug} />
            </li>
        ))}
    </ul>
);

export const VendorDetailCommercials = (props: IProps) => {
    const {offers, vendorSlug} = props;

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(4)]}>
                Nowe lokale użytkowe
            </Text>

            <VendorDetailCommercialsList offers={offers.slice(0, 5)} vendorSlug={vendorSlug} />

            {offers.length > 5 && (
                <ShowMoreButton showMoreText="Pokaż więcej inwestycji" showLessText="Pokaż mniej inwestycji">
                    <VendorDetailCommercialsList offers={offers.slice(5)} vendorSlug={vendorSlug} />
                </ShowMoreButton>
            )}
        </>
    );
};

const commercialsOffersList = css`
    list-style: none;
    padding-left: 0;
    margin: 0;
`;
